import { UnifiedConnectionProvider } from "@common/schemas/organization-unified-connection.schema";

/**
 * Providers whose raw connection ids are integers, and so are namespaced to
 * stay unique against the uuid-keyed native connections they are unioned with.
 */
const PREFIXED_PROVIDERS: UnifiedConnectionProvider[] = [
    "plaid",
    "stripe",
    "ramp",
];

/**
 * The id a connection is addressed by across the unified connections API — the
 * key of a `login` group, and what the org integrations table rows are keyed
 * on. Both the server building the response and the client asking for a
 * specific connection go through here so the two can't drift.
 */
export const unifiedConnectionId = ({
    provider,
    connectionId,
}: {
    provider: UnifiedConnectionProvider;
    connectionId: string;
}): string =>
    PREFIXED_PROVIDERS.includes(provider)
        ? `${provider}:${connectionId}`
        : connectionId;
